var map = {
	"./features.json": [
		"./wp-data/features.json",
		"features-json"
	],
	"./fitness.json": [
		"./wp-data/fitness.json",
		"fitness-json"
	],
	"./food.json": [
		"./wp-data/food.json",
		"food-json"
	],
	"./health-education.json": [
		"./wp-data/health-education.json",
		"health-education-json"
	],
	"./miscellaneous.json": [
		"./wp-data/miscellaneous.json",
		"[request]"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./wp-data lazy recursive ^\\.\\/.*\\.json$";
module.exports = webpackAsyncContext;